export const state = {
  notifications: false,
  message: undefined,
  type: 'warning'
}

export const getters = {
  notifications (state) {
    return state.notifications
  },
  message (state) {
    return state.message
  },
  type (state) {
    return state.type
  }
}

export const mutations = {
  SET_NOTIFICATION (state, newValue) {
    state.notifications = newValue
  },
  SET_MESSAGE (state, newValue) {
    state.message = newValue
  },
  SET_TYPE (state, newValue) {
    state.type = newValue
  }
}
export const actions = {
  setNotification ({ commit, dispatch, state }, data) {
    commit('SET_NOTIFICATION', data.active)
    commit('SET_MESSAGE', data.message)
    commit('SET_TYPE', data.type)
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/message.js